import React from "react"
import { format, fromUnixTime } from "date-fns"

function CancellationNotice({ date }) {
  return (
    <div className="bg-red-600 py-6 px-4">
      <div className="container mx-auto px-3 leading-tight">
        <h3 className="text-white font-bold mb-3">
          Your account will expire soon
        </h3>

        <p className="text-white m-0 mb-1">
          As you have disabled auto-renewal, your account will expire on{" "}
          {format(fromUnixTime(date), "dd/MM/yyyy")}. If you would like to
          enable auto-renewal and keep your account, please visit your customer
          portal.
        </p>
      </div>
    </div>
  )
}

export default CancellationNotice
